import React from "react";
import { map } from "utils/lodash";
import BookingCard from "./BookingCard";

import { BOOKING_STATUS } from "utils/constant";
import List from "components/common/List";
import Expand from "components/common/Expand";
import cx from "classnames";
import helper from "utils/helper";
import { get, keys, filter } from "utils/lodash";
import { useBookingStore, useShopStore } from "stores";
import dayjs from "utils/dayjs";

const mockBookings: any = [
  {
    id: 1,
    customerName: "Minh Hiền",
    time: "09:00 - 10:30",
    date: "02/02/2020",
    service: "Gội đầu dưỡng sinh thư giãn, massage",
    status: BOOKING_STATUS.WAITING,
    seat: 1,
  },
  {
    id: 11,
    customerName: "Minh Hiền",
    time: "09:00 - 10:30",
    date: "02/02/2020",
    service: "Gội đầu dưỡng sinh thư giãn, massage",
    status: BOOKING_STATUS.ACCEPTED,
    seat: 1,
  },
  {
    id: 2,
    customerName: "Cẩm Tú",
    time: "10:30 - 12:00",
    date: "02/02/2020",
    service: "Gội đầu dưỡng sinh thư giãn, massage",
    status: BOOKING_STATUS.DONE,
    seat: 1,
  },
  {
    id: 3,
    customerName: "Trâm Anh",
    time: "13:00 - 14:30",
    date: "02/02/2020",
    service: "Gội đầu dưỡng sinh thư giãn, massage",
    status: BOOKING_STATUS.USER_CANCEL,
    seat: 1,
  },
  {
    id: 4,
    customerName: "Khánh Linh",
    time: "15:00 - 16:30",
    date: "02/02/2020",
    service: "Gội đầu dưỡng sinh thư giãn, massage",
    status: BOOKING_STATUS.SHOP_CANCEL,
    seat: 1,
  },
];

const blockTimes = [
  {
    id: 1,
    time: "09:00 - 10:30",
    date: "02/02/2020",
  },
  {
    id: 2,
    time: "10:30 - 12:00",
    date: "02/02/2020",
  },
  {
    id: 3,
    time: "13:00 - 14:30",
    date: "02/02/2020",
  },
];

export default function TimeFrame({
  onAccept,
  onMore,
}: {
  onAccept?: (booking: any) => void;
  onMore?: (booking: any) => void;
}) {
  const { bookings, selectedDate } = useBookingStore();
  const { shop } = useShopStore();

  // Filter bookings for current selected date
  const currentBookings = filter(bookings || [], (booking: any) => {
    return dayjs(get(booking, "bookingDate")).isSame(
      selectedDate,
      "day"
    );
  });

  const groupedBookings = helper.groupBookingsByTimeSlot({
    bookings: currentBookings,
    shop,
    bookingDate: selectedDate,
  });

  const _keys: any = keys(groupedBookings).sort((a, b) => {
    // Extract start time from format "HH:mm-HH:mm"
    const getMinutes = (timeSlot: string) => {
      const [hours, minutes] = timeSlot.split("-")[0].split(":").map(Number);
      return hours * 60 + minutes;
    };
    return getMinutes(a) - getMinutes(b);
  });
  return (
    <div className="h-full overflow-y-auto pb-4 scrollbar-hide">
      {_keys && _keys.length > 0 ? (
        <Expand
          defaultActiveKey={_keys.map((item: any) => `${item}`)}
          alwaysExpanded={true}
          items={_keys}
          title={(item) => `Khung giờ: ${item}`}
          renderItem={(item: any) => {
            const timeSlotBookings = get(groupedBookings, item, []);
            return timeSlotBookings.length > 0 ? (
              <div className="flex flex-col gap-4">
                {map(timeSlotBookings, (booking) => (
                  <BookingCard
                    data={helper.formatBooking(booking)}
                    key={booking.id}
                    onMore={onMore}
                    onAccept={onAccept}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-4 text-gray-500">
                Chưa có lịch hẹn trong khung giờ này
              </div>
            );
          }}
        />
      ) : (
        <div className="flex flex-col items-center justify-center py-16">
          <div className="text-gray-400 mb-3">
            <svg width="72" height="72" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
              <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2"/>
              <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2"/>
              <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
              <circle cx="12" cy="16" r="2" fill="currentColor" opacity="0.5"/>
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2">
            Chưa có lịch hẹn nào
          </h3>
          <p className="text-gray-500 text-center max-w-xs px-4">
            Các lịch hẹn theo khung giờ sẽ được hiển thị tại đây khi có khách đặt lịch.
          </p>
        </div>
      )}
    </div>
  );
}
